/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListModelCatalogAccessRequest = {
  modelId: string;
};

/** @internal */
export const ListModelCatalogAccessRequest$inboundSchema: z.ZodType<
  ListModelCatalogAccessRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  model_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "model_id": "modelId",
  });
});
/** @internal */
export type ListModelCatalogAccessRequest$Outbound = {
  model_id: string;
};

/** @internal */
export const ListModelCatalogAccessRequest$outboundSchema: z.ZodType<
  ListModelCatalogAccessRequest$Outbound,
  z.ZodTypeDef,
  ListModelCatalogAccessRequest
> = z.object({
  modelId: z.string(),
}).transform((v) => {
  return remap$(v, {
    modelId: "model_id",
  });
});

export function listModelCatalogAccessRequestToJSON(
  listModelCatalogAccessRequest: ListModelCatalogAccessRequest,
): string {
  return JSON.stringify(
    ListModelCatalogAccessRequest$outboundSchema.parse(
      listModelCatalogAccessRequest,
    ),
  );
}
export function listModelCatalogAccessRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListModelCatalogAccessRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListModelCatalogAccessRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListModelCatalogAccessRequest' from JSON`,
  );
}
